import { createStore, createLogger } from 'vuex'
import setting from './setting'
import auth from './auth'

const debug = process.env.NODE_ENV !== 'production'

export default createStore({
  state: {
    shareOffcanvas: false,
    lang: localStorage.getItem('appLang') || 'en'
  },
  getters: {
    shareOffcanvas: (state) => state.shareOffcanvas,
    lang: (state) => state.lang
  },
  mutations: {
    openBottomCanvasCommit(state, payload) {
      state[payload.name] = payload.value
    },
    setLang(state, lang) {
      state.lang = lang
      localStorage.setItem('appLang', lang)
    }
  },
  actions: {
    openBottomCanvasAction({ commit }, payload) {
      commit('openBottomCanvasCommit', payload)
    },
    setLang({ commit }, lang) {
      commit('setLang', lang)
    }
  },
  modules: {
    setting: setting,
    auth: auth
  },
  strict: debug,
  plugins: debug ? [createLogger()] : []
})
